import { createActions } from 'redux-actions';
import types from 'state/mrDistribution/ui/actionTypes';

const { mrDistribution } = createActions({
  [types.SET_FETCHING]: (isFetching) => ({ isFetching }),
  [types.SET_SUBMITTING]: (isSubmitting) => ({ isSubmitting }),
});

export default mrDistribution;
